var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCirclePlay = function SvgCirclePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    x: 1,
    y: 1,
    stroke: "#A4AAB6",
    strokeWidth: 2,
    rx: 23
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A4AAB6",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M35.557 22.754c.959.554 1.438.83 1.438 1.245 0 .416-.48.692-1.438 1.246L19.299 34.63c-.958.553-1.438.83-1.797.623-.36-.208-.36-.761-.36-1.868V14.613c0-1.107 0-1.66.36-1.868.36-.207.839.07 1.797.623l16.258 9.386Z"
  })));
};
export default SvgCirclePlay;